<template>
    <div>
        <div class="top">
            <van-nav-bar title="迎接新生" left-text="返回" left-arrow @click-left="onClickLeft"/>
        </div>
        <div class="news" v-for="(item,index) in newsList" :key="index">
            <!--三图-->
            <div class="news-item" v-if="item.picnum === 3" @click="goDetail(item.id)">
                <div class="news-title">{{item.title}}</div>
                <div class="news-img">
                    <div class="img-three" v-for="(i,index) in item.thumb" :key="index">
                        <img :src="i">
                    </div>
                </div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
            <!--二图-->
            <div class="news-item" v-if="item.picnum === 2" @click="goDetail(item.id)">

                <div class="news-title">{{item.title}}</div>
                <div class="news-img">
                    <div class="img-two" v-for="(i,index) in item.thumb" :key="index">
                        <img :src="i">
                    </div>
                </div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
            <!--单图-->
            <div class="news-item" v-if="item.picnum === 1" @click="goDetail(item.id)">
                <div class="news-one">
                    <div class="title-one">{{item.title}}</div>
                    <div class="img-one" v-for="(i,index) in item.thumb" :key="index">
                        <img :src="i">
                    </div>
                </div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
            <!--无图-->
            <div class="news-item" v-if="item.picnum === 0">
                <div class="news-title">{{item.title}}</div>
                <div class="create-time">{{item.create_time}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {httpPost,httpGet} from "../../../../axios/index";

    export default {
        name: "schoolInfo",
        data() {
            return {
                newsList:[]
            }
        },
        methods: {
            // 进入详情
            goDetail(e){
                this.$router.push({
                     path:"/bzNewsDetail",
                      query:{
                          id:e
                      }
                }                                                 
                )
            },
           
            onClickLeft() {
                this.$router.go(-1);
            },
            selectMenu(item){
                this.currentId = item.id
            },
            loadInfo() {
                httpPost(                  
                  "/saas/lists",
                     {schoolid: this.$route.query.id, mark: 13}
                )
                    .then(response => {
                        if (response.code === 1) {
                            this.newsList = response.data;
                        }
                    })
            }
        },
        mounted() {
            this.loadInfo();
        }
    }
</script>

<style scoped>
    img{
        width: 100%;
        height: 100%;
    }
    .news{
        background: #fff;
    }
    .news-item{
        padding:0.8rem 0;
        border-bottom: 0.05rem solid #ccc;
    }
    .news-title{
        font-size: 1rem;
        padding-left: 0.3rem;
        padding-bottom: 0.5rem;
    }
    .news-one{
        display: flex;
    }
    .img-one{
        width: 35vw;
        height: 6rem;
        margin-left: 5vw;
    }
    .title-one{
        width: 55vw;
        font-size: 1rem;
        padding-left: 0.5rem;
    }
    .create-time{
        padding-left: 0.3rem;
        padding-top: 0.6rem;
        color: #999;
    }
    .news-img{
        display: flex;
        justify-content: space-around;
    }
    .img-three{
        width: 30vw;
        height: 5rem;
    }
    .img-two{
        width: 45vw;
        height: 6rem;
    }
</style>